<template>
  <div>
    <router-view></router-view>
    <ConfirmDialog />
  </div>
</template>

<script>
import ConfirmDialog from "@/components/tools/ConfirmDialog";

export default {
  name: "App",
  components: { ConfirmDialog },
  data: () => ({}),
};
</script>

<style>
html {
  overflow-y: auto;
}
</style>
